import {
  Input as InputPrimitive,
  Checkbox as CheckboxPrimitive,
  RadioGroup as RadioGroupPrimitive,
  Textarea as TextAreaPrimitive,
  Dropdown as DropdownPrimitive,
  Select as SelectPrimitive,
} from '@fluentui/react-components';
import {
  withValidation,
  ValidationGroup,
  withError,
  CheckedItemAdapter,
} from '@bingads-webui-react/validation';

import { ValidatedField, withErrorField } from './src/validated-field';
import { FluentDropdownAdapter } from './src/fluentDropdownAdapter';

export { ValidatedField, withErrorField };
export { FluentDropdownAdapter };

export const InputLite = withValidation(InputPrimitive);
export const Input = withError(InputLite);
export const InputField = withErrorField(InputLite);

export const TextAreaLite = withValidation(TextAreaPrimitive);
export const TextArea = withError(TextAreaLite);
export const TextAreaField = withErrorField(TextAreaLite);

export const CheckboxLite = withValidation(CheckboxPrimitive, CheckedItemAdapter);
export const Checkbox = withError(CheckboxLite);
export const CheckboxField = withErrorField(CheckboxLite);

export const RadioGroupLite = withValidation(RadioGroupPrimitive);
export const RadioGroup = withError(RadioGroupLite);
export const RadioGroupField = withErrorField(RadioGroupLite);

export const DropdownLite = withValidation(DropdownPrimitive, FluentDropdownAdapter);
export const Dropdown = withError(DropdownLite);
export const DropdownField = withErrorField(DropdownLite);

export const SelectLite = withValidation(SelectPrimitive);
export const Select = withError(SelectLite);
export const SelectField = withErrorField(SelectLite);

export { ValidationGroup };
export const ValidationGroupWithErrors = withError(ValidationGroup);

export * from './src/types';
